// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1B9VU","rightAdornment":"Header_rightAdornment__1Rtnb"};